import React from 'react';
import {HashRouter, Route, Switch} from 'react-router-dom';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {store} from './redux/store';
import {unregister} from './registerServiceWorker';
import '../scss/style.scss'
// Containers
import Protected from './components/Protected/';
import Landing from './components/Landing/';
import Signup from './components/Signup/';
import Signin from './components/Signin/';
import PasswordRecovery from './components/PasswordRecovery/';
import NewPassword from './components/NewPassword/';
import ErrorPage from "./components/ErrorPage";
import SignChecker from "./views/SignChecker";

unregister();

if (process.env.title) {
    document.title = `${process.env.title} - registry`;
}

render(
    <Provider store={store}>
        <HashRouter>
            <Switch>
                <Route exact path="/" component={Signin}/>
                <Route path="/sign-checker" component={SignChecker}/>
                <Route path="/user" render={routeProps => <Protected {...routeProps}/>}/>
                <Route path="/signup" component={Signup}/>
                <Route path="/confirmation" render={routeProps => <Landing {...routeProps}/>}/>
                <Route path="/password_recovery" component={PasswordRecovery}/>
                <Route path="/password/recovery" component={NewPassword}/>
                {/*<Route path="/error" component={ErrorPage}/>*/}
                <Route path="/error" render={routeProps => <ErrorPage {...routeProps}/>}/>
            </Switch>
        </HashRouter>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js